import { EVENTS } from '../constants/webSocketConsts/events';
import {
  addFormResponses,
  deleteFormResponses,
} from '../store/intake_forms/actions';

const FormRequestHandler = (event: string, items: Array<any>) => {
  switch (event) {
    case EVENTS.INSERT:
      return addFormResponses(items);
    default:
    case EVENTS.REMOVE:
      return deleteFormResponses(items);
  }
  return null;
};

export default FormRequestHandler;
